export function toNumber(value, fallback = 0){
    const n = Number(value);
    return Number.isFinite(n) ? n : fallback;
};

export function template(templateid, data) {
  return document.getElementById(templateid).innerHTML.replace(
    /%(\w*)%/g, // or /{(\w*)}/g for "{this} instead of %this%"
    function (m, key) {
      return data.hasOwnProperty(key) ? data[key] : "";
    }
  );
}

export function sanitizeFilename(name) {
  return String(name || "")
    .replace(/[<>:"/\\|?*\x00-\x1F]/g, "_")  // windows forbidden + control chars
    .replace(/\s+/g, " ")
    .trim()
    .slice(0, 180); // keep it reasonable
}

export function compare(s1, s2, insensitive) {
  let _string_a = insensitive ? s1.toLowerCase() : s1;
  let _string_b = insensitive ? s2.toLowerCase() : s2;
  return _string_a.localeCompare(_string_b);
}

export function right(value, length, defaultValue) {
  return value?.length >= length ? value.substr(value.length - length, value.length) : defaultValue || "";
}

export function left(value, length, defaultValue="") {
  return value?.length >= length ? value.substr(0, length): defaultValue || "";
}

export function ssn(value, obscured) {
  value = String(value ?? "").replace(/\D/g, "");
  if (value.length === 9) {
    const a = value.slice(0, 3);
    const b = value.slice(3, 5);
    const c = value.slice(5, 9);
    value = `${a}-${b}-${c}`;
  }

  return (value.length === 11) ? obscured ? "XXX-XX-" + right(value, 4) : value : "(unknown)";
}

export function phone(value) {
  let cleaned = ("" + value).replace(/\D/g, "");
  let match = cleaned.match(/^(\d{1})(\d{3})(\d{3})(\d{4})$/);
  if (match) {
    return "(" + match[2] + ") " + match[3] + "-" + match[4];
  }
  match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);
  if (match) {
    return "(" + match[1] + ") " + match[2] + "-" + match[3];
  }
  return null;
}

export function isEmail(value) {
  if (!value) return false;
  // pragmatic email check
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(String(value).trim());
}

export function isGuid(value) {
  const pattern = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;
  return !!String(value ?? "").match(pattern);
}

export function generate(baseKey, usedKeys, maximumLength) {
    const MAX_LEN = maximumLength;
    const CHARS = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ"; // numbers, then letters
    const BASE = CHARS.length;

    // Ensure baseKey exists and is max 8 chars
    baseKey = (baseKey || "").slice(0, MAX_LEN);

    const used = new Set(usedKeys || []);

    // If baseKey is free, just use it
    if (!used.has(baseKey)) return baseKey;

    // Start counter at 1 so we first try baseKey + "1"
    let counter = 1;

    while (true) {
        // Convert counter to base-36 using CHARS
        let n = counter;
        let suffix = "";
        while (n > 0) {
            const idx = n % BASE;
            suffix = CHARS[idx] + suffix;
            n = Math.floor(n / BASE);
        }

        if (suffix.length > MAX_LEN) {
            // Theoretically, you’ve exhausted the key space
            throw new Error("Unable to generate unique key: exhausted key space");
        }

        // Make room for suffix by trimming baseKey from the right if needed
        const prefixLen = MAX_LEN - suffix.length;
        const prefix = baseKey.slice(0, prefixLen);
        const candidate = prefix + suffix;

        if (!used.has(candidate)) {
            return candidate;
        }

        counter++;
    }
}